import "@babel/polyfill";
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import "@/design/main.scss"
// @ts-ignore
import print from "vue3-print-nb"

createApp(App).use(router).use(ElementPlus).use(print).mount('#app')
